export {
  clearMaterialLoadCache,
  loadMaterialModules,
  webMaterialManifest,
} from "./web/material-manifest";
export { h5MaterialManifest } from "./h5/material-manifest";
export { webMaterialManifest as materialManifest } from "./web/material-manifest";
export type {
  LoadMaterialModulesOptions,
  LoadedMaterialModules,
  MaterialLoadOptions,
  MaterialLoader,
  MaterialManifest,
  MaterialManifestEntry,
  MaterialRuntimeModule,
} from "./web/material-manifest";

import type { PagePlatform } from "@mijalowcode/types";
import { h5MaterialManifest } from "./h5/material-manifest";
import { webMaterialManifest } from "./web/material-manifest";

export function getMaterialManifestByPlatform(platform: PagePlatform) {
  return platform === "h5" ? h5MaterialManifest : webMaterialManifest;
}

export { columnsRequestAdapter } from "./runtime-adapters/columns-request";
export { listTemplateAdapter } from "./runtime-adapters/list-template";
export { defaultComponentAdapterRegistry } from "./runtime-adapters";
